import { getApiClient } from "@/api/clientRegistry";
import type { ApiResponse } from "@/types/api";
import type { SearchSchoolData } from "@/types/school";

const gatewayApi = getApiClient('gateway');

export const getSchoolDetails = async (schoolId: string) => {
  const requestBody = {
    school_code: schoolId,
  };
  const response = await gatewayApi.post<ApiResponse<SearchSchoolData>>(
    "v2/school/search-school",
    requestBody,
    {
      params: {
        page: 1,
        page_size: 100,
      },
    }
  );

  return response.data;
};
